import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "q-py-md" }
const _hoisted_2 = {
  key: 0,
  class: "text-h6 q-pb-md q-px-md"
}
const _hoisted_3 = { class: "q-pt-md q-px-md" }
const _hoisted_4 = { class: "q-pt-md" }
const _hoisted_5 = { class: "q-pt-md" }
const _hoisted_6 = { class: "row q-pt-md" }
const _hoisted_7 = { class: "col-6 q-pr-sm" }
const _hoisted_8 = { class: "col-6" }

import { PropType, ref } from "vue";
  import { QInput } from "quasar";
  
  import { Customer, LoanApplication } from "src/types/loan-application/index";

  import Flag from "src/components/shared/Flag.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BankDetailsForm',
  props: {
    customer: {
      type: Object as PropType<Customer>,
      default: {} as Customer
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, { expose: __expose }) {

  const props = __props

  const bankNameInput = ref<QInput | null>(null);
  const bankMonthsInput = ref<QInput | null>(null);
  const accountNameInput = ref<QInput | null>(null);
  const accountNumberInput = ref<QInput | null>(null);
  const sortCodeInput = ref<QInput | null>(null);

  __expose({ validate })
  function validate() {
    let valid = true;

    bankNameInput.value!.validate() ? null : valid = false;
    bankMonthsInput.value!.validate() ? null : valid = false;
    accountNameInput.value!.validate() ? null : valid = false;
    accountNumberInput.value!.validate() ? null : valid = false;
    sortCodeInput.value!.validate() ? null : valid = false;

    return valid;
  }

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Bank Details "))
      : _createCommentVNode("", true),
    (__props.showTitle)
      ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "q-pb-xs text-overline text-weight-bold text-uppercase text-dark" }, "Bank Name *", -1)),
        _createVNode(_unref(QInput), {
          modelValue: __props.customer.bankName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.customer.bankName) = $event)),
          ref_key: "bankNameInput",
          ref: bankNameInput,
          rules: [val => !!val || 'Required'],
          dense: "",
          "data-clarity-mask": "True",
          outlined: ""
        }, null, 8, ["modelValue", "rules"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "q-pb-xs text-overline text-weight-bold text-uppercase text-dark" }, "Time at Bank (Months) *", -1)),
        _createVNode(_unref(QInput), {
          modelValue: __props.customer.bankMonthsAt,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.customer.bankMonthsAt) = $event)),
          modelModifiers: { number: true },
          ref_key: "bankMonthsInput",
          ref: bankMonthsInput,
          "hide-spin-buttons": "",
          dense: "",
          rules: [val => !!val || 'Required'],
          "data-clarity-mask": "True",
          type: "number",
          min: "0",
          outlined: ""
        }, null, 8, ["modelValue", "rules"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "q-pb-xs text-overline text-weight-bold text-uppercase text-dark" }, "Name on Account *", -1)),
        _createVNode(_unref(QInput), {
          modelValue: __props.customer.bankAccountName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.customer.bankAccountName) = $event)),
          ref_key: "accountNameInput",
          ref: accountNameInput,
          dense: "",
          rules: [val => !!val || 'Required'],
          "data-clarity-mask": "True",
          outlined: ""
        }, null, 8, ["modelValue", "rules"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "q-pb-xs text-overline text-weight-bold text-uppercase text-dark" }, "Account No *", -1)),
          _createVNode(_unref(QInput), {
            modelValue: __props.customer.bankAccountNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.customer.bankAccountNumber) = $event)),
            ref_key: "accountNumberInput",
            ref: accountNumberInput,
            type: "number",
            rules: [val => !!val || 'Required', val => val && val.length === 8 || 'Must be 8 digits'],
            "hide-spin-buttons": "",
            dense: "",
            "data-clarity-mask": "True",
            outlined: ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "q-pb-xs text-overline text-weight-bold text-uppercase text-dark col-6" }, "Sort Code *", -1)),
          _createVNode(_unref(QInput), {
            modelValue: __props.customer.bankSortCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.customer.bankSortCode) = $event)),
            ref_key: "sortCodeInput",
            ref: sortCodeInput,
            pattern: "[0-9]",
            rules: [val => !!val || 'Required', val => val && val.length === 8 || 'Must be 6 digits'],
            dense: "",
            "data-clarity-mask": "True",
            outlined: "",
            mask: "##-##-##"
          }, null, 8, ["modelValue", "rules"])
        ])
      ])
    ])
  ]))
}
}

})